var Student = "นักเรียน";
var jobRole = {
	"Job role": "ตำแหน่งงาน",
	"Academic / Researcher": "นักวิจัย / นักวิชาการ",
	"Advisor / Consultant": "ที่ปรึกษา / ผู้ให้คำปรึกษา",
	"Business Executive": "ผู้บริหารธุรกิจ",
	"Developer / Engineer": "นักพัฒนา / วิศวกร",
	"Entrepreneur (Founder/Co-Founder)": "ผู้ประกอบการ (ผู้ก่อตั้ง/ผู้ก่อตั้งร่วม)",
	"IT Executive": "ผู้บริหารฝ่าย IT",
	"IT Professional or Technical Manager": "ผู้เชี่ยวชาญฝ่าย IT หรือผู้จัดการฝ่ายเทคนิค",
	"Press / Media Analyst": "สื่อ / นักวิเคราะห์สื่อ",
	"Sales / Marketing": "พนักงานขาย / การตลาด",
	Student: Student,
	"Solution or Systems Architect": "สถาปนิกด้านโซลูชันหรือระบบ",
	"System Administrator": "ผู้ดูแลระบบ",
	"Venture Capitalist": "นักลงทุนในกิจการร่วมลงทุน"
};

export { Student, jobRole as default };
